var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9520",
    "data-name": "Rectangle 9520",
    width: 23.234,
    height: 28,
    fill: "#90a0b7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34064",
    "data-name": "Group 34064",
    transform: "translate(-15.969 -12.507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Check_box",
    "data-name": "Check box",
    transform: "translate(15.838 12.376)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3854",
    "data-name": "Rectangle 3854",
    width: 39,
    height: 39,
    transform: "translate(0.131 0.131)",
    fill: "#a54545",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31654",
    "data-name": "Group 31654",
    transform: "translate(23.852 18.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31654-2",
    "data-name": "Group 31654",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68610",
    "data-name": "Path 68610",
    d: "M16.383,15.489H6.851a.894.894,0,0,0,0,1.787h9.532a.894.894,0,0,0,0-1.787m-3.574,4.766H6.851a.894.894,0,0,0,0,1.787h5.957a.894.894,0,0,0,0-1.787m0,0H6.851a.894.894,0,0,0,0,1.787h5.957a.894.894,0,0,0,0-1.787m3.574-4.766H6.851a.894.894,0,0,0,0,1.787h9.532a.894.894,0,0,0,0-1.787m0,0H6.851a.894.894,0,0,0,0,1.787h9.532a.894.894,0,0,0,0-1.787m-3.574,4.766H6.851a.894.894,0,0,0,0,1.787h5.957a.894.894,0,0,0,0-1.787m0,0H6.851a.894.894,0,0,0,0,1.787h5.957a.894.894,0,0,0,0-1.787m3.574-4.766H6.851a.894.894,0,0,0,0,1.787h9.532a.894.894,0,0,0,0-1.787m0,0H6.851a.894.894,0,0,0,0,1.787h9.532a.894.894,0,0,0,0-1.787m-3.574,4.766H6.851a.894.894,0,0,0,0,1.787h5.957a.894.894,0,0,0,0-1.787m8.078-13.75L16.729,2.359A8.021,8.021,0,0,0,11.069,0H5.66A5.68,5.68,0,0,0,0,5.66V22.34A5.68,5.68,0,0,0,5.66,28H17.574a5.665,5.665,0,0,0,5.66-5.66V12.189a8.035,8.035,0,0,0-2.347-5.683M13.7,2.395l.441.25a6.172,6.172,0,0,1,1.323.965l4.146,4.158A6.281,6.281,0,0,1,20.6,9.091l.238.441H15.191A1.49,1.49,0,0,1,13.7,8.043ZM21.447,22.34a3.88,3.88,0,0,1-3.872,3.872H5.66A3.88,3.88,0,0,1,1.787,22.34V5.66A3.88,3.88,0,0,1,5.66,1.787h5.386a2.464,2.464,0,0,1,.417.036l.453.048V8.043a3.282,3.282,0,0,0,3.277,3.277h6.172l.048.453a2.572,2.572,0,0,1,.036.417Zm-5.064-6.851H6.851a.894.894,0,0,0,0,1.787h9.532a.894.894,0,0,0,0-1.787m-3.574,4.766H6.851a.894.894,0,0,0,0,1.787h5.957a.894.894,0,0,0,0-1.787m0,0H6.851a.894.894,0,0,0,0,1.787h5.957a.894.894,0,0,0,0-1.787m3.574-4.766H6.851a.894.894,0,0,0,0,1.787h9.532a.894.894,0,0,0,0-1.787m0,0H6.851a.894.894,0,0,0,0,1.787h9.532a.894.894,0,0,0,0-1.787m-3.574,4.766H6.851a.894.894,0,0,0,0,1.787h5.957a.894.894,0,0,0,0-1.787m0,0H6.851a.894.894,0,0,0,0,1.787h5.957a.894.894,0,0,0,0-1.787m3.574-4.766H6.851a.894.894,0,0,0,0,1.787h9.532a.894.894,0,0,0,0-1.787m0,0H6.851a.894.894,0,0,0,0,1.787h9.532a.894.894,0,0,0,0-1.787m-3.574,4.766H6.851a.894.894,0,0,0,0,1.787h5.957a.894.894,0,0,0,0-1.787m0,0H6.851a.894.894,0,0,0,0,1.787h5.957a.894.894,0,0,0,0-1.787m3.574-4.766H6.851a.894.894,0,0,0,0,1.787h9.532a.894.894,0,0,0,0-1.787",
    transform: "translate(0 0)",
    fill: "#90a0b7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.7ed5b87318beae706b9d9286d9b6f146.svg";
export { ForwardRef as ReactComponent };